import { Stack } from '@mui/material';
import dayjs from 'dayjs';
import { Control } from 'react-hook-form';
import { CONSUMPTION_FILTER_BUTTONS_CONFIG } from '../../entity';
import DateRangeFilters from '@shared/components/DateRangeFilters';
import FilterButtons from '@shared/components/FilterButtons';
import { DayJsRange, StockViewKey } from '@shared/entity';

type ConsumptionFiltersProps = {
  control: Control<Partial<DayJsRange>>;
  activeView: StockViewKey;
  onViewChange: (view: StockViewKey) => void;
  onDateFromChange: (date?: dayjs.Dayjs | null) => void;
  onDateToChange: (date?: dayjs.Dayjs | null) => void;
};

const ConsumptionFilters = ({
  control,
  activeView,
  onViewChange,
  onDateFromChange,
  onDateToChange,
}: ConsumptionFiltersProps) => (
  <Stack spacing={4}>
    <FilterButtons
      activeFilter={activeView}
      filterButtonsConfig={CONSUMPTION_FILTER_BUTTONS_CONFIG}
      onChange={onViewChange}
    />
    <DateRangeFilters
      control={control}
      onChangeFrom={onDateFromChange}
      onChangeTo={onDateToChange}
    />
  </Stack>
);
export default ConsumptionFilters;
